import {initialise} from 'ui-article/axel-publication-content/js';
import ArticleStore from './CabiArticleStore';
import ArticleView from './CabiArticleView';
import config from './config';
import templates from './templates';

initialise({ArticleStore, ArticleView, config, templates});
